export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/identity.js
// module id = ./node_modules/d3-format/src/identity.js
// module chunks = 1